import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const formatDateTime = (d) => d ? new Date(d).toLocaleString() : '—';

export default function ClaimTimeline({ history }) {
  if (!history || history.length === 0) return <Typography color="textSecondary">No status history yet.</Typography>;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {history.map((h) => (
        <Paper key={h.id} variant="outlined" sx={{ p: 1.5 }}>
          <Typography variant="caption" color="textSecondary">{formatDateTime(h.changed_at)}</Typography>
          <Typography variant="body2"><strong>{h.new_status}</strong></Typography>
          {h.change_reason && <Typography variant="caption">{h.change_reason}</Typography>}
        </Paper>
      ))}
    </Box>
  );
}
